import type { QuestionThreadEntry } from './QuestionThread'

/**
 * Whether the thread waits on the agent: its newest entry is not the agent's.
 * A follow-up from the investor after a reply therefore makes it wait again.
 * Entries are oldest first.
 */
export function isAwaitingAgentReply(entries: readonly QuestionThreadEntry[]): boolean {
  const newest = entries[entries.length - 1]
  return newest !== undefined && newest.sender !== 'agent'
}
